module.exports = __webpack_public_path__ + "img/logo_colour.38ea04e5.png";